import React from 'react'
import styled from 'styled-components'

const Loader = styled.div`
    position:absolute;
    top:50%;
    left:50%;
    transform:translate(-50%,-50%);

h1 {
    position: relative;
    color: rgba(0, 0, 0, .3);
    font-size: 5em;
    line-height:5em;
    text-align:center;
}
h1:before {
    content: attr(data-text);
    line-height:5em;
    max-width:100%;
    position: absolute;
    top:0;
    left:0;
    overflow: hidden;
    white-space: nowrap;
    color: #fff;
    animation: loading 0.5s linear infinite;
}
@keyframes loading {
    0% {
        max-width: 0;
    }
}
@media screen and (max-width:768px){
    h1{
        font-size:2em;
    }
}
`

export default () => {
    return (
        <>
            <Loader ><br /><br />
                <h1 data-text={'Loading...'}>{'Loading...'}</h1>
            </Loader >
        </>
    )
}